/**
 * Switches between different cases based on a given value.
 * @param {string | number} value - The value to be checked.
 * @param {Record<string | number, any>} cases - An object containing the different cases and their corresponding values.
 * @returns The value of the matching case, or null if no match is found.
 */
export const switchCase = (value: string | number, cases: Record<string | number, any>) => {
    return value in cases ? cases[value] : "default" in cases ? cases["default"] : null;
};
